import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=5e5ed0de&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=5e5ed0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ed0de",
  null
  
)

export default component.exports